export function expandReplyForm() {
  $(document).on('click', '.reply-button', (e) => {
    e.preventDefault();
    const parent = $(e.target).closest('.reply-message');
    $(parent).find('.reply-form').toggle();
  });

  $(document).on('click', '.reply-form .cancel-button', (e) => {
    e.preventDefault();
    const parent = $(e.target).closest('.reply-message');
    $(parent).find('.reply-form').toggle();
    $(parent).find('.buttons-row').addClass('is-hidden');
    const conversationId = $(parent).closest('.conversation-expanded-info').prop('id').split('-')[1];
    $(`#textarea-note-response-${conversationId}`).trumbowyg('empty');
  });
}

export function expandUpdateForm() {
  $(document).on('click', '.message .edit-message', (e) => {
    e.preventDefault();
    const parent = $(e.target).closest('.message');
    $(parent).find('.message-cnt').toggle();
    $(parent).find('.message-form').toggle();
  });

  $(document).on('click', '.message-form .cancel-button', (e) => {
    e.preventDefault();
    const parent = $(e.target).closest('.message');
    $(parent).find('.message-cnt').toggle();
    $(parent).find('.message-form').toggle();
    const messageId = $(e.target).closest('.message-form').prop('id').split('-')[1];
    $(`#edit-message-${messageId}`).trumbowyg('html', $(parent).find('.message-cnt').html());
  });
}
